import React from "react";
import { connectionSteps } from "../constants";

const ConnectionRecommendations = () => {
  return (
    <div>
      <h4 className="font-medium text-black text-base leading-6 mb-3 dark:text-white">
        Before you start
      </h4>
      <ul>
        {connectionSteps.map(({ id, step }) => (
          <li
            key={id}
            className="text-semiBlack text-base leading-6 dark:text-semiWhite"
          >
            {step}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ConnectionRecommendations;
